var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMoneyRemain({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99922 1.69141V2.94141C14.143 2.94141 17.4992 6.29766 17.4992 10.4414C17.4992 14.5852 14.143 17.9414 9.99922 17.9414V19.1914C14.8305 19.1914 18.7492 15.2727 18.7492 10.4414C18.7492 5.61016 14.8305 1.69141 9.99922 1.69141Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14922 16.1539L4.34297 17.1102C5.11172 17.7602 5.99297 18.2789 6.95547 18.6352L7.38047 17.4602C6.55547 17.1539 5.79922 16.7102 5.14297 16.1539H5.14922Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61797 11.6914L1.38672 11.9477C1.56172 12.9664 1.91172 13.9227 2.41172 14.7852L3.49297 14.1914C3.06797 13.4539 2.76797 12.5602 2.61797 11.6914Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49297 6.69141L2.41172 6.06641C1.91797 6.92891 1.56797 7.91641 1.38672 8.93516L2.61797 9.15391C2.76797 8.28516 3.06797 7.43516 3.49297 6.69766V6.69141Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38672 3.41641L6.96172 2.24141C5.99922 2.59766 5.11797 3.11641 4.34922 3.76641L5.15547 4.72266C5.81172 4.16641 6.56797 3.72266 7.39297 3.41641H7.38672Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1242 7.94141V6.69141H10.6242V4.81641H9.37422V6.69141H8.12422C7.43484 6.69141 6.87422 7.25203 6.87422 7.94141V9.81641C6.87422 10.5058 7.43484 11.0664 8.12422 11.0664H11.8742V12.9414H6.87422V14.1914H9.37422V16.0664H10.6242V14.1914H11.8742C12.5636 14.1914 13.1242 13.6305 13.1242 12.9414V11.0664C13.1242 10.377 12.5636 9.81641 11.8742 9.81641H8.12422V7.94141H13.1242Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoneyRemain);
export default __webpack_public_path__ + "static/media/ic-money-remain.3c18c6f47b15a8f47d30d0186eb21bc0.svg";
export { ForwardRef as ReactComponent };